module.exports = __webpack_public_path__ + "img/polygon.744b751f.gif";